import type { Email } from '../types'

export default [
  {
    subject: 'Ta dyrevelferd seriøst',
    body: `Kjære {target_name},
Jeg bor og stemmer i valgdistriktet {custom}. Jeg vil at du skal stemme følgende:
1. Minst 50% mer plass for gris.
2. Forby produksjonen av buregg.
3. Stoppe oppdrettsnæringen
4.
5.

Mvh, {full_name}
{phone}`,
  },
  {
    subject: '22222222',
    body: `Kjære {target_name},
Jeg bor og stemmer i valgdistriktet {custom}. Jeg vil at du skal stemme følgende:
1. Minst 50% mer plass for gris.
2. Forby produksjonen av buregg.
3. Stoppe oppdrettsnæringen

Mvh, {full_name}
{phone}`,
  },
] as Email[]
